export const toLegacyQuiz = (formData = {}) => {
    const keys = Object.keys(formData),
        len = keys.length;

    return ({
        num_answered: len,
        num_correct: len,
        num_questions: len,
        passed: true,
        submit: true,
        summary: keys.map(k => ({
            question: k,
            answers: [formData[k]],
            correct_answer: ""
        }))
    });
};